<template>
    <article
        class="sticky-bar"
    >
        <slot />
    </article>
</template>

<style lang="less">
.sticky-bar {
    position: sticky;
    top: 3.6875rem;
    z-index: 2;

    padding: 0 0 var(--spacing-xl);

    background-color: var(--color-lightest);

    @media @q-md-min {
        display: none;
    }
}


[data-searching='true'] .sticky-bar {
    position: static;
}

.sticky-bar[data-full-width] {
    margin-left: calc(-50vw + 50%);
    width: 100vw;
}
</style>